
export default {
  methods: {
    snackbarError(data , errorTime = '2000') {
      if(data.response?.data?.errorCode || data.response.status) {
        const errorCode = data.response?.data?.errorCode || data.response.status
        this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', errorTime, 'mdi-alert-octagon')
      }else{
        console.error('[APP][] ERROR:', data)
      }
    }
  }
};
